import React, { useState } from 'react';

const SERVICES = [
  { emoji: '🚕', name: 'Book a Taxi',    desc: 'Hail a ride anywhere in Morocco', accent: '#FBBF24' },
  { emoji: '🍔', name: 'Food Delivery',  desc: 'Order from local restaurants',    accent: '#FB7185' },
  { emoji: '🚗', name: 'Car Rental',     desc: 'Rent a car, day or week',        accent: '#34D399' },
];

const accentRgb = { '#FBBF24': '251,191,36', '#FB7185': '251,113,133', '#34D399': '52,211,153' };

const ServicesAppScreen = () => {
  const [active, setActive] = useState(0);
  const svc = SERVICES[active];

  return (
    <div style={{
      background: '#0F0F0F',
      height: '100%',
      fontFamily: 'Inter, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      padding: '14px',
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <div style={{
          width: '28px', height: '28px', borderRadius: '9px',
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8B93A7" strokeWidth="2">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
        </div>
        <p style={{ color: '#F5F1EA', fontSize: '15px', fontWeight: '700', margin: 0 }}>Services</p>
      </div>

      <p style={{ color: '#8B93A7', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px' }}>
        Choose a service
      </p>

      {/* Service cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
        {SERVICES.map((s, i) => (
          <div
            key={s.name}
            onClick={() => setActive(i)}
            style={{
              background: active === i ? `rgba(${accentRgb[s.accent]},0.08)` : 'rgba(255,255,255,0.03)',
              border: active === i ? `1px solid ${s.accent}44` : '1px solid rgba(255,255,255,0.06)',
              borderRadius: '14px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            <div style={{
              width: '40px', height: '40px', borderRadius: '12px',
              background: `${s.accent}18`, border: `1px solid ${s.accent}30`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '18px', flexShrink: 0,
            }}>
              {s.emoji}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ color: active === i ? '#F5F1EA' : '#8B93A7', fontSize: '12px', fontWeight: '700', margin: '0 0 2px' }}>{s.name}</p>
              <p style={{ color: '#8B93A7', fontSize: '9px', margin: 0 }}>{s.desc}</p>
            </div>
            <span style={{
              background: 'rgba(255,255,255,0.06)', borderRadius: '20px', padding: '3px 7px',
              fontSize: '7px', color: '#8B93A7', fontWeight: '700', flexShrink: 0,
            }}>Coming Soon</span>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ marginTop: '12px' }}>
        <div style={{
          background: `linear-gradient(135deg, ${svc.accent}, ${svc.accent}bb)`,
          borderRadius: '12px', padding: '12px', textAlign: 'center',
          boxShadow: `0 6px 20px ${svc.accent}33`,
        }}>
          <span style={{ color: '#0F0F0F', fontSize: '12px', fontWeight: '800' }}>
            Coming Soon
          </span>
        </div>
        <p style={{ color: '#8B93A7', fontSize: '9px', textAlign: 'center', margin: '6px 0 0' }}>
          Paid from your MAD wallet
        </p>
      </div>
    </div>
  );
};

export default ServicesAppScreen;
